var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-2"},_vm._l((_vm.categories),function(item){return _c('generic-category-item',{key:item.id,attrs:{"data":item},on:{"click":function($event){return _vm.openCategory(item)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }